import { useState } from 'react';
import type { OutreachRow } from '@discovr/types';

/** Keeps showing the last row for this entry while a replacement read is in flight. */
export function useStickyRow(entryId: string | null, live: OutreachRow | null): OutreachRow | null {
  const [last, setLast] = useState<OutreachRow | null>(null);
  if (live && live !== last) setLast(live);
  return live ?? (entryId !== null && last?.entryId === entryId ? last : null);
}
